import { ROUTES as accountsRoutes } from '../../modules/accounts/pages/routes'
import { ROUTES as adminRoutes } from '../../modules/admin/pages/routes'
import { ROUTES as dashboardRoutes } from '../../modules/analytics/routes'
import { ROUTES as authRoutes } from '../../modules/auth/pages/routes'
import { ROUTES as customersRoutes } from '../../modules/customers/pages/routes'
import { ROUTES as inventoryRoutes } from '../../modules/inventory/pages/routes'
import { ROUTES as InvoiceRoutes } from '../../modules/invoice/pages/routes'
import { ROUTES as locationsRoutes } from '../../modules/locations/pages/routes'
import { ROUTES as onboardingRoutes } from '../../modules/onboarding/pages/routes'
import { ROUTES as ordersRoutes } from '../../modules/orders/routes'
import { ROUTES as paymentsRoutes } from '../../modules/payments/pages/routes'
import { ROUTES as planningRoutes } from '../../modules/planning/pages/routes'
import { ROUTES as supportRoutes } from '../../modules/support/routes'
import { ROUTES as vendorsRoutes } from '../../modules/vendors/pages/routes'
import OtpGuardTest from '../components/OtpGuardTest'

interface Route {
  path: string
  component: React.ComponentType<any>
  isProtected: boolean
  showMenu: boolean
  slug: string
  title: string
  redirectTo?: string
  isExact?: boolean
  guard?: (_children: React.ReactNode) => React.ReactNode
}

export const ROUTES: Route[] = [
  ...ordersRoutes,
  ...authRoutes,
  ...adminRoutes,
  ...onboardingRoutes,
  ...accountsRoutes,
  ...customersRoutes,
  ...vendorsRoutes,
  ...paymentsRoutes,
  ...dashboardRoutes,
  ...inventoryRoutes,
  ...InvoiceRoutes,
  ...locationsRoutes,
  ...supportRoutes,
  ...planningRoutes,
  // Test route for OTP guard
  {
    component: OtpGuardTest,
    isProtected: false,
    showMenu: false,
    path: '/otp-test',
    slug: 'otp-test',
    title: 'OTP Guard Test',
  },
]
